import script from "./FrotaDash.vue?vue&type=script&setup=true&lang=js"
export * from "./FrotaDash.vue?vue&type=script&setup=true&lang=js"

import "./FrotaDash.vue?vue&type=style&index=0&id=4e67d269&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4e67d269"]])

export default __exports__